import { ApplicantsStoreService } from '@hb/modules/applicants/applicants-store.service';
import { IncomeOption } from '@hb/domain';
import { environment } from '@hb/hypotheken-berekening.environment';
import { PreviousButtonComponent } from '@hb/modules';
import { StartersDispensationComponent } from '@hb/modules/applicants/starters-dispensation/starters-dispensation.component';
import { IncomeInputComponent } from '@hb/modules/applicants/income-input/income-input.component';
import { DateOfBirthComponent } from '@hb/modules/applicants/date-of-birth/date-of-birth.component';
import { AowInfoComponent } from '@hb/modules/applicants/aow-info/aow-info.component';
import { StartersDispensationInfoComponent } from '@hb/modules/applicants/starters-dispensation-info/starters-dispensation-info.component';
import content from '@hb/hypotheken-berekening.content.json';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';

import { ApContentModule, ApContentService } from '@ap/content';

@Component({
    selector: 'income',
    styleUrls: ['./applicants.component.scss'],
    templateUrl: './applicants.component.html',
    standalone: true,
    imports: [
        ApContentModule,
        ReactiveFormsModule,
        AsyncPipe,
        PreviousButtonComponent,
        StartersDispensationComponent,
        IncomeInputComponent,
        DateOfBirthComponent,
        AowInfoComponent,
        StartersDispensationInfoComponent
    ]
})
export class ApplicantsComponent implements OnInit {
    protected readonly store = inject(ApplicantsStoreService);
    protected readonly contentService = inject(ApContentService);

    protected readonly environment = environment;
    protected readonly incomeOption = IncomeOption;
    activeOption: IncomeOption;

    ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.store.getActiveOption().subscribe((question) => (this.activeOption = question));
    }

    previousQuestion(): void {
        this.store.backOption();
    }
}
